import type { IAuthState } from "./types";

export const getUser = (state: { auth: IAuthState }) => state.auth.user;
export const selectIsAuthenticated = (state: { auth: IAuthState }) =>
  state.auth.isAuthenticated;
export const selectUserRole = (state: { auth: IAuthState }) =>
  state.auth.user?.role;
